module.exports = __webpack_public_path__ + "img/train_disabled.46d38f0f.svg";